import React, {useEffect, useState} from 'react';
import AllNoticesTable from "./components/allNoticesTable";
import config from "../../config/apiService.json";
import fetchData from "../../utils/fetchData";
import TableDataSizePerPage from "./components/tableDataSizePerPage";
import '../../assets/css/pages/allNotices/style.scss';
import DynamicPagination from "../../components/pagination/dynamicPagination";
import DataLoader from "../../components/loader/dataLoader";

const Index = () => {
    const [data, setData] = useState();
    const [showLoader, setShowLoader] = useState(true);
    const [showDataPerPage, setShowDataPerPage] = useState(5);
    const {notices: noticesApiEndPoint} = config;
    const [total, setTotal] = useState();
    const [activePage, setActivePage] = useState(1);

    const getData = async () => {
        // const result = await fetchData(`${notices}`);
        const result = await fetchData(`${noticesApiEndPoint}?currentPage=${activePage - 1}&recordPerPage=${showDataPerPage}`);
        const {total, notices} = result;
        setTotal(total);
        setData(notices);
    }

    useEffect(() => {
        setShowLoader(true);
        getData();
        setShowLoader(false);
    }, []);

    useEffect(() => {
        setShowLoader(true);
        getData();
        setShowLoader(false);
    }, [showDataPerPage, activePage]);

    const handlePaginate = (clickedPaginatePageNumber) => {
        setActivePage(clickedPaginatePageNumber)
    }

    const handleTableDataSizePerPageSelectChange = (e) => {
        const pageSize = e.target.value;
        setActivePage(1);
        setShowDataPerPage(pageSize);
    }
    return (
        <section className='notices'>
            <div className='custom-container'>
                <div className='content-section'>
                    <h1 className='page-title'>e-Notice board</h1>
                    <div className='content-body'>
                        {showLoader && <DataLoader/>}
                        {data && total &&
                            <>
                                <TableDataSizePerPage
                                    onChange={handleTableDataSizePerPageSelectChange}
                                />
                                <AllNoticesTable
                                    notices={data}
                                    activePage={activePage}
                                    pageSize={showDataPerPage}
                                />
                                <DynamicPagination
                                    activePage={activePage}
                                    itemsPerPage={showDataPerPage}
                                    totalItems={total}
                                    handlePaginateButtonClick={handlePaginate}
                                />
                            </>
                        }
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Index;
